// NOTE: it may make sense to utilize / add calls to
// enrollmentService.js. In which case, this file is not needed
import sponsorMock from './sponsorMock.json';
const AE_API = '/sitecore/api/ssc/rw/isagenix/assistedenrollmentapi';

export async function resetMemberPlacement(data) {
    return $.ajax({
        headers: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val()},
        type: 'GET',
        contentType: 'application/json',
        dataType: 'json',
        url: `${AE_API}/resetMemberPlacement`,
        data: data
    });
}

export async function searchDownlineSponsor(data) {
    if($('.patternlab__body').length > 0) {
        return new Promise((resolve, reject) => {
            setTimeout(() => { resolve(sponsorMock); }, 500);
        });
    }
    return $.ajax({
        headers: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val()},
        type: 'GET',
        contentType: 'application/json',
        dataType: 'json',
        url: `${AE_API}/searchDownlineSponsor`,
        data: data
    });
}

export async function searchPlacementSponsor(data) {
    if($('.patternlab__body').length > 0) {
        return new Promise((resolve, reject) => {
            setTimeout(() => { resolve(sponsorMock); }, 500);
        });
    }
    return $.ajax({
        headers: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val()},
        type: 'GET',
        contentType: 'application/json',
        dataType: 'json',
        url: `${AE_API}/searchPlacementSponsor`,
        data: data
    });
}

export async function saveSponsor(data) {
    return $.ajax({
        headers: {__RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val()},
        type: 'POST',
        url: `${AE_API}/AddOrUpdateEnrollmentPlacementInfoToCart`,
        data: data
    });
}

export async function deleteAECarts() {
    let token = $('input[name="__RequestVerificationToken"]').val();
    return $.ajax({
        type: 'POST',
        url: `${AE_API}/deleteAEcarts`,
        headers: { __RequestVerificationToken: token }
    });
}

export async function saveAsisistedEnrollmentSession() {
    let token = $('input[name="__RequestVerificationToken"]').val();
    return $.ajax({
        type: 'POST',
        url: `${AE_API}/saveAssistedEnrollmentSession`,
        headers: { __RequestVerificationToken: token }
    });
}
